import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import "../../App.css"
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Nav, Form, Dropdown, Image, Button, Modal, Row, Col } from 'react-bootstrap';
import UserService from '../../service/UserService';
import profileicon from "../../asset/images/logo/avatar-7.jpg"
import { useNavigate,useParams } from 'react-router-dom';
import { Fragment } from 'react';
import { resetPassword } from "../api/resetpassword";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Passwordimg from "../../asset/images/portal/password.png"
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function MenuHeader() {
    const { institute } = useParams(); // Extract institute code from URL
    const navigate = useNavigate();
    const isAuthenticated = UserService.isAuthenticated();
    const userName = typeof window !== "undefined" ? localStorage.getItem("email") || "Anonymous" : null;
    const email = typeof window !== "undefined" ? localStorage.getItem("email") || "Anonymous" : null;
    const userId = typeof window !== "undefined" ? localStorage.getItem("id") || "Anonymous" : null;
    const [showPassword, setShowPassword] = useState(false);
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const ins = typeof window !== "undefined" ? localStorage.getItem("institute") : null;
    const [show, setShow] = useState(false);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    const handleLogout = () => {
        const confirmDelete = window.confirm('Are you sure you want to logout this user?');
        if (confirmDelete) {
            UserService.logout();
            localStorage.removeItem("ins")
            console.log("localStorage after logout (institute):", localStorage.getItem("institute"));
            console.log("localStorage after logout:", localStorage);

            if (ins) {
                navigate(`/${ins}`);
               
            } else {
                navigate('/'); 
            }
        }
    };

    const isDesktop = useMediaQuery({
        query: '(min-width: 1224px)'
    })


    const handleConfirm = async () => {
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }
        const resetPasswordRequest = {
            userId: userId,
            currentPassword: currentPassword,
            newPassword: newPassword,
        };
        try {
            const response = await resetPassword(resetPasswordRequest, token);
            console.log("Response for reset password:", response)
            if (response.status === 200) {
                toast.success("Password reset successfully.");
            }
            else {
                toast.error("Error resetting password")
            }
        } catch (error) {
            console.error("Error resetting password:", error);
            setError("Failed to reset password. Please try again.");
        }
    };

    const MenuDesktop = () => {
        return (
            <>
                <Navbar className='bg_d_blue bg-body-tertiary' collapseOnSelect expand="lg" >
                    <Container>
                        <Navbar.Collapse id="responsive-navbar-nav" className='justify-content-end'>
                            <Nav style={{
                                display: "flex",
                                alignItems: "baseline"
                            }}>
                                <p className='l_grey1' style={{ marginRight: '14px' }} >{userName}</p>
                                <Dropdown as="li" className="ms-2" style={{ marginTop: "2px" }}>
                                    <Dropdown.Toggle
                                        as="a"
                                        bsPrefix=' '
                                        className="rounded-circle"
                                        id="dropdownUser">
                                        <div className="avatar avatar-md avatar-indicators avatar-online" >
                                            <Image alt="avatar" src={profileicon} className="profileimg" />
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                        className="dropdown-menu dropdown-menu-end "
                                        align="end"
                                        aria-labelledby="dropdownUser"
                                        style={{ width: "250px" }}
                                    >
                                        <Dropdown.Item as="div" className="px-4 pb-0 pt-2" bsPrefix=' '>
                                            <div className="lh-1 ">
                                                <h4 className="mb-2 " style={{ whiteSpace: 'nowrap', fontSize: "15px" }}>Hello, {userName}</h4>

                                                <h5 className="mb-2 " style={{ fontSize: "15px", fontWeight: "600" }}>Email: {email}</h5>
                                            </div>
                                            <div className=" dropdown-divider mt-3 mb-2"></div>
                                        </Dropdown.Item>

                                        <div className='text_c'>
                                            <Button className='mt-2 mb-2' onClick={handleShow}>
                                                <i className="bi bi-box-arrow-right" style={{ marginRight: "5px" }}></i>Reset Password
                                            </Button>
                                            <Button onClick={handleLogout}>
                                                <i className="bi bi-box-arrow-right" style={{ marginRight: "5px" }}></i>Logout
                                            </Button>

                                        </div>

                                    </Dropdown.Menu>
                                </Dropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </>
        );
    }

    const MenuMobile = () => {
        return (
            <>
                <Navbar className='bg_d_blue bg-body-tertiary' collapseOnSelect expand="lg" >
                    <Container>
                        {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ marginLeft: "auto" }} /> */}
                        <Navbar className='mobilenavbar' style={{ marginLeft: "auto" }} >
                            <Nav className='mobilenav'>
                                <Dropdown as="li" className="ms-2" style={{ marginTop: "2px" }}>
                                    <Dropdown.Toggle
                                        as="a"
                                        bsPrefix=' '
                                        className="rounded-circle"
                                        id="dropdownUser">
                                        <div className="avatar avatar-md avatar-indicators avatar-online" >
                                            <Image alt="avatar" src={profileicon} className="profileimg" />
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                        className="dropdown-menu dropdown-menu-end "
                                        align="end"
                                        aria-labelledby="dropdownUser"
                                        style={{ width: "250px" }}

                                    >
                                        <Dropdown.Item as="div" className="px-4 pb-0 pt-2" bsPrefix=' '>
                                            <div className="lh-1 ">
                                                <h4 className="mb-2 " style={{ whiteSpace: 'nowrap', fontSize: "15px" }}>Hello, {userName}</h4>

                                                <h5 className="mb-2 " style={{ fontSize: "15px", fontWeight: "600" }}>Email: {email}</h5>
                                            </div>
                                            <div className=" dropdown-divider mt-3 mb-2"></div>
                                        </Dropdown.Item>

                                        <div className='text_c'>
                                            <Button className='mt-2 mb-2' onClick={handleShow}>
                                                <i className="bi bi-box-arrow-right" style={{ marginRight: "5px" }} ></i>Reset Password
                                            </Button>
                                            <Button onClick={handleLogout}>
                                                <i className="bi bi-box-arrow-right" style={{ marginRight: "5px" }}></i>Logout
                                            </Button>

                                        </div>

                                    </Dropdown.Menu>
                                </Dropdown>
                            </Nav>
                        </Navbar>
                    </Container>
                </Navbar>
            </>
        );
    }
    return (
        <Fragment>
            {isDesktop ? <MenuDesktop /> : <MenuMobile />}
            {/* Modal */}
            <Modal show={show} onHide={handleClose} centered>
                <div style={{
                    display: "flex",
                    justifyContent: "center", marginTop: "-30px"
                }}>
                    <div style={{ backgroundColor: "#6e48aa", height: "90px", width: "90px", borderRadius: "100%", boxShadow: "rgba(60, 64, 67, 0.3) 0px 4px 7px 0px, rgba(60, 64, 67, 0.15) 0px 4px 1px 1px" }}>
                        <img src={Passwordimg} style={{
                            height: "60px",
                            width: "60px", margin: "16%"
                        }} />
                    </div>
                </div>
                <Modal.Header closeButton>
                    <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                        className="mt-2"> Reset Password</Form.Label>

                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="mb-3">
                            <Form.Label
                                className="col-sm-4 col-form-label form-label">
                                Current Password<span className="text-danger">*</span>
                            </Form.Label>
                            <Col sm={7} className="mb-3 mb-lg-0">
                                <Form.Control
                                    type={showCurrentPassword ? "text" : "password"}
                                    placeholder="Enter Current Password"
                                    id="currentpassword"
                                    required
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                <span
                                    className="position-absolute end-0 top-50 translate-middle-y pe-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                >
                                    {showCurrentPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px" }} />}
                                </span>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Form.Label
                                className="col-sm-4 col-form-label form-label">
                                New Password<span className="text-danger">*</span>
                            </Form.Label>
                            <Col sm={7} className="mb-3 mb-lg-0">
                                <Form.Control
                                    type={showNewPassword ? "text" : "password"}
                                    placeholder="Enter New Password"
                                    id="newpassword"
                                    required
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <span
                                    className="position-absolute end-0 top-50 translate-middle-y pe-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                >
                                    {showNewPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px" }} />}
                                </span>
                            </Col>
                        </Row>
                        <Row >
                            <Form.Label
                                className="col-sm-4 col-form-label form-label">
                                Confirm Password<span className="text-danger">*</span>
                            </Form.Label>
                            <Col sm={7} className="mb-lg-0">
                                <Form.Control
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Enter New Password Again"
                                    id="confirmpassword"
                                    required
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <span
                                    className="position-absolute end-0 top-50 translate-middle-y pe-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                    {showConfirmPassword ? <VisibilityIcon style={{
                                        color: "#8697c4", fontSize: "20px"
                                    }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px" }} />}
                                </span>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <ToastContainer />
                </Modal.Footer>
            </Modal>
        </Fragment>
    )

}

export default MenuHeader;